import { delData, getData, postData, patchData } from '../../../utils/fetch-api-util';
import { GameProfileQuestion, GameProfileQuestionSummaryResponse } from '../../../types/gameProfileQuestion';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface GameProfileQuestionRequestParams {
  search?: string;
  answerType?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  limit?: number;
  country?: string | null;
}

export interface GameProfileQuestionSet {
  gameProfileGroupSetId: string;
  gameProfileGroupSetName: string;
  createdAt: string;
  updatedAt: string;
  startTime: string | null;
  endTime: string | null;
  disabled: boolean;
  questions: GameProfileQuestion[];
}

export interface GameProfileQuestionResponse {
  total: number;
  page: number;
  limit: number;
  questionSets: GameProfileQuestionSet[];
}

interface SuccessResponse {
  success: boolean;
}

export const getGameProfileQuestionsRepository = async (
  params?: GameProfileQuestionRequestParams,
): Promise<GameProfileQuestionResponse> => {
  const queryParams = new URLSearchParams();

  if (params?.search) queryParams.append('search', params.search);
  if (params?.answerType) queryParams.append('answerType', params.answerType);
  if (params?.fromDate) queryParams.append('fromDate', params.fromDate);
  if (params?.toDate) queryParams.append('toDate', params.toDate);
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.limit) queryParams.append('limit', params.limit.toString());
  if (params?.country) queryParams.append('country', params.country);

  const url = `${API_URLS.GAME_PROFILE_QUESTIONS_LIST_API}${
    queryParams.toString() ? `?${queryParams.toString()}` : ''
  }`;
  const response = await getData<any, GameProfileQuestionResponse>(url);
  return response.data;
};

export const createGameProfileQuestionRepository = async (payload: Partial<GameProfileQuestion>): Promise<void> => {
  await postData<Partial<GameProfileQuestion>, SuccessResponse>(API_URLS.GAME_PROFILE_QUESTIONS_API, payload);
};

export const updateGameProfileQuestionRepository = async (payload: Partial<GameProfileQuestion>): Promise<void> => {
  await patchData<Partial<GameProfileQuestion>, SuccessResponse>(
    API_URLS.GAME_PROFILE_QUESTIONS_UPDATE_API(payload?.id || ''),
    payload,
  );
};

export const deleteGameProfileQuestionRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.GAME_PROFILE_QUESTIONS_UPDATE_API(id));
};

export const sortGameProfileQuestionsRepository = async (payload: any): Promise<void> => {
  await postData<any, SuccessResponse>(API_URLS.GAME_PROFILE_QUESTIONS_SORT_API, payload);
};

export const updateGameProfileQuestionStatusRepository = async (id: string, status: boolean): Promise<void> => {
  await postData<{ disabled: boolean }, SuccessResponse>(API_URLS.GAME_PROFILE_QUESTIONS_UPDATE_STATUS_API(id), {
    disabled: status,
  });
};

export const getGameProfileQuestionSummaryRepository = async (
  id: string,
): Promise<GameProfileQuestionSummaryResponse> => {
  const response = await getData<any, GameProfileQuestionSummaryResponse>(
    API_URLS.GAME_PROFILE_QUESTIONS_SUMMARY_API(id),
  );
  return response.data;
};

export const getGameProfileQuestionDetailRepository = async (id: string): Promise<GameProfileQuestion> => {
  const response = await getData<any, GameProfileQuestion>(API_URLS.GAME_PROFILE_QUESTIONS_DETAIL_API(id));
  return response.data;
};
